export const addDaysToDate = (
  value: string | null,
  days: number
): string | null => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  date.setDate(date.getDate() + days);
  return date.toISOString();
};

export const formatMultiplierDate = (
  value: string | null,
  uppercase = false
) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  const formattedDate = date.toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "long",
  });
  return uppercase ? formattedDate.toUpperCase() : formattedDate;
};
